import React from "react";
import moment from "moment";

import { getImageUrl } from "../../final-qa/lib/productData";
import { buildAttributeItems } from "../lib/helpers";
import { ImagePopout } from "components/image-stream/image-popout";
import { NO_IMAGE_URL } from "../lib/constants";

const MatchItem = ({ product, attributeList, isSelected, onCompareClick, upc, codingWipKey }) => {
    const today = moment();
    const updatedOn = today.diff(product.updatedOn, "days") || "-";
    const [frontShot] = product.images.filter(({ cxhAssetName }) => cxhAssetName.includes("Front"));
    const [firstShot] = product.images;
    const defaultShot = firstShot ? getImageUrl(firstShot.cxHImageAttributeValue, { size: 1000 }) : NO_IMAGE_URL;

    const attributeItems = buildAttributeItems(product.productId, product.attributes, attributeList);
    const cssClass = isSelected ? "product -matchable -active" : "product -matchable";

    return (
        <li
            key={product.productId}
            className={cssClass}
            onClick={() => {
                onCompareClick(product);
            }}
        >
            <div className="top-info -link-wrapper">
                <ImagePopout
                    photoKey={`${product.productId}_image`}
                    alt="Front"
                    isInModal={true}
                    srcOverride={frontShot ? getImageUrl(frontShot.cxHImageAttributeValue, { size: 400 }) : defaultShot}
                    upc={upc}
                    codingWipKey={codingWipKey}
                    productId={product.productId}
                />
                <div>{updatedOn} Days Ago</div>
            </div>
            <ul className="attribute-list">{attributeItems}</ul>
        </li>
    );
};

export default MatchItem;
